/**
 * Rejects on timeout
 * @param {Number} ms
 * @returns {Promise}
 */
export default function timeout(ms) {
    return new Promise((_, reject) => setTimeout(reject, ms));
}
